import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import logoImage from '../assets/instabizweb.jpeg';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err.response?.data?.message;
      setError(
        msg ||
          (err.code === 'ERR_NETWORK' ? t('login.serverError') : null) ||
          t('login.loginFailed')
      );
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-bg-orb login-bg-orb-1" />
      <div className="login-bg-orb login-bg-orb-2" />
      <div className="login-card">
        <div className="login-showcase">
          <div className="login-logo">
            <img
              src={logoImage}
              alt={t('login.imgAlt')}
              className="login-brand-logo"
            />
          </div>
          <div className="login-showcase-points">
            <div className="login-point">{t('login.bullet1')}</div>
            <div className="login-point">{t('login.bullet2')}</div>
            <div className="login-point">{t('login.bullet3')}</div>
          </div>
        </div>

        <div className="login-form-panel">
          <h2 className="login-form-title">{t('login.welcomeBack')}</h2>
          <p className="login-form-subtitle">{t('login.signInSubtitle')}</p>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('login.emailLabel')}</label>
              <input
                type="email"
                placeholder={t('login.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>{t('login.passwordLabel')}</label>
              <input
                type="password"
                placeholder={t('login.passwordPlaceholder')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
              {loading ? t('login.signingIn') : t('login.signIn')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
